import type { K8sdiagFocus } from "@k8s-dashboard/contracts";
import {
  deleteViewer as widgetDeleteViewer,
  putViewer as widgetPutViewer,
  type DiagnoseTransport,
} from "@k8s-dashboard/diagnose-widget";
import { getManagerToken, getSessionCSRF } from "./client";

/** 세션 모드는 쿠키와 CSRF만 보내고, 기존 manager 모드는 Bearer를 보냅니다.
 * 스트림 요청은 자동 재시도하지 않습니다. 세션 갱신은 AuthGate가 담당합니다.
 */
export const diagnoseTransport: DiagnoseTransport = (path, init) => {
  const bearer = getManagerToken();
  const csrf = getSessionCSRF();
  return fetch(`/api/v1/k8sdiag${path}`, {
    credentials: "same-origin",
    ...init,
    headers: {
      ...init?.headers,
      ...(csrf ? { "X-CSRF-Token": csrf } : {}),
      ...(bearer ? { Authorization: `Bearer ${bearer}` } : {}),
    },
  });
};

export const agentTransport: DiagnoseTransport = (path, init) => {
  const bearer = getManagerToken();
  const csrf = getSessionCSRF();
  return fetch(`/api/v1/agents${path}`, {
    credentials: "same-origin",
    ...init,
    headers: {
      ...init?.headers,
      ...(csrf ? { "X-CSRF-Token": csrf } : {}),
      ...(bearer ? { Authorization: `Bearer ${bearer}` } : {}),
    },
  });
};

/** 인증되지 않은 화면에서는 viewer 등록을 생략합니다. */
export function putViewer(focus: K8sdiagFocus): Promise<void> {
  if (!getManagerToken() && !getSessionCSRF()) return Promise.resolve();
  return widgetPutViewer(diagnoseTransport, focus);
}

export function deleteViewer(): Promise<void> {
  if (!getManagerToken() && !getSessionCSRF()) return Promise.resolve();
  return widgetDeleteViewer(diagnoseTransport);
}
